import { ReactNode, useEffect, useRef } from 'react'
import * as THREE from 'three'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import './three-gradient.css'

const TWEEN = require('@tweenjs/tween.js')
const win:any = window;
const minTime = 2000;
const maxTime = 1000;

interface Props {
  showImages?:boolean
  children: ReactNode
}

const ThreeGradient = (props: Props) => {

  const threeCanvasRef = useRef<HTMLDivElement>(null)
  const renderer = useRef<any>(undefined)
  const scene = useRef<any>(undefined)
  const fbxLoader = useRef<any>(undefined)
  const camera = useRef<any>(undefined)
  const lightPurple = useRef<any>(undefined)
  const lightYellow = useRef<any>(undefined)
  const mouseTarget = useRef<any>({x:0, y:0})

  const lerp = (start, end, amt) => {
    return (1-amt)*start+amt*end
  }

  const onMouseMove = (evt) => {
    let mouseX = -(0.5 - (evt.clientX / evt.view.innerWidth))
    let mouseY = (0.5 - (evt.clientY / evt.view.innerHeight)) * 1.5
    mouseTarget.current = {x: mouseX, y: mouseY}
  }

  const onResize = () => {
    camera.current.aspect = window.innerWidth / window.innerHeight
    camera.current.updateProjectionMatrix()
    renderer.current.setSize( window.innerWidth, window.innerHeight )
  }

  const animateToPositionPurple = (target:any) => {
    let animProps = {x: target.position.x, y: target.position.y}
    new TWEEN.Tween(animProps)
      .easing(TWEEN.Easing.Quadratic.InOut)
      .to({x: 1+ ((Math.random() * 0.4) - 0.2), y: Math.random()}, minTime + (Math.random() * maxTime))
      .to({x: 1+ ((Math.random() * 0.4) - 0.2), y: -Math.random()}, minTime + (Math.random() * maxTime))
      .onUpdate(() => {
        target.position.set(animProps.x, animProps.y, 1)
      })
      .onComplete(() => {
        animateToPositionPurple(target)
      })
      .start()
  }

  const animateToPositionYellow = (target:any) => {
    let animProps = {x: target.position.x, y: target.position.y}
    new TWEEN.Tween(animProps)
      .easing(TWEEN.Easing.Quadratic.InOut)
      .to({x: -1 + ((Math.random() * 0.4) - 0.2), y: 1}, minTime + (Math.random() * maxTime))
      .to({x: -1 + ((Math.random() * 0.4) - 0.2), y: -1}, minTime + (Math.random() * maxTime))
      .onUpdate(() => {
        target.position.set(animProps.x, animProps.y, 1)
      })
      .onComplete(() => {
        animateToPositionYellow(target)
      })
      .start()
  }

  const animate = () => {
    requestAnimationFrame( animate )

    TWEEN.update()

    lightPurple.current.position.set(1, lerp(lightPurple.current.position.y, mouseTarget.current.y, 0.02), 1)
    lightYellow.current.position.set(-1, -lerp(lightPurple.current.position.y, mouseTarget.current.y, 0.02), 1)
    renderer.current.render(scene.current, camera.current)
  }

  useEffect(() => {

    scene.current = new THREE.Scene()
    fbxLoader.current = new FBXLoader()

    let element = threeCanvasRef.current!
    let aspect = element.clientWidth / element.clientHeight

    camera.current = new THREE.PerspectiveCamera( 45, element.clientWidth / element.clientHeight, 0.1, 1000 )

    win.onmousemove = onMouseMove

    renderer.current = new THREE.WebGLRenderer()
    renderer.current.setSize( element.clientWidth, element.clientHeight )
    element.appendChild( renderer.current.domElement )

    let lightMult = 2.5

    lightPurple.current = new THREE.PointLight( 0x511635, 7 * lightMult, 1.6 )
    lightPurple.current.position.set( 1, 0.2, 1 )
    lightPurple.current.layers.set(0)
    scene.current.add( lightPurple.current )

    lightYellow.current = new THREE.PointLight( 0x2c2516, 10 * lightMult, 1.6 )
    lightYellow.current.position.set( -1, 0, 1 )
    lightYellow.current.layers.set(0)
    scene.current.add( lightYellow.current )

    camera.current.position.x = 0
    camera.current.position.y = 0
    camera.current.position.z = 1

    window.onresize = onResize

    fbxLoader.current.load(
      '/fbx/plane.fbx',
      (object) => {
        object.material = new THREE.MeshLambertMaterial( { color: 0xffffff } )
        object.position.set(0, 0, 0)
        object.scale.set(100,100,1)
        object.layers.set(0)
        scene.current.add( object )
      },
      (xhr) => {
      },
      (error) => {
          console.log(error)
      }
    )

    animate();

  }, [])

  return (
    <div className='three-gradient'>
      <div className='renderer-container' ref={threeCanvasRef}></div>
      {
        props.showImages && props.showImages === true ? (
          <div className='overlay-container'>
            <img className='wifi' src='/img/illustrations/transparent-wifi.png' />
            <img className='sim' src='/img/illustrations/transparent-Sim.png' />
          </div>
        ) : null
      }
      <div className='child-container'>
        { props.children }
      </div>
    </div>
  );
}

export default ThreeGradient
